import React from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  Button
} from 'reactstrap'
import { Link } from 'react-router-dom';
import ColoredLineHr from './UI/ColoredLineHr'
import { PropTypes } from "prop-types"
import Http from '../Http'
import { Line, } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { FormatNumberInEur } from './Utils'
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp, faArrowDown, faEquals } from '@fortawesome/free-solid-svg-icons'

library.add(faArrowUp, faArrowDown, faEquals)


class ClientEvolutionDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      chartDetailsTitle: '',
      chartDetailsDescription: '',
      chartDetailsChartData: null,
      chartDetailsChartOptions: null,
      clientData: [],
      chartFatturatoData: {
        datasets: [],
        labels: [],
      },
      chartDeltaOptions: {
        tooltips: {
          mode: 'nearest',
          callbacks: {
            label: function (tooltipItem, data) {
              let delta = data.datasets[tooltipItem.datasetIndex].dataValues[tooltipItem.index]
              return data.datasets[tooltipItem.datasetIndex].label + ": " + (delta > 0 ? "+" + delta + "%" : delta + "%");
            }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return FormatNumberInEur(value, true)
              },
              maxTicksLimit: 5,
              fontColor: "#fff"
            },
            scaleLabel: {
              display: true,
              labelString: 'Fatturato',
              padding: 10,
              fontColor: "#fff"
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: "#fff"
            }
          }]
        },
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return FormatNumberInEur(value, false)
            },
            color: '#fff'
          }
        },
        legend: {
          display: false
        },
        aspectRatio: 1.4,
        layout: {
          padding: {
            right: 80
          }
        }
      },
      showEditMode: false,
    }
    this.api = '/api/v1';
    //QCLIENT: env aggiungere api link

    this.toggleEditMode = this.toggleEditMode.bind(this)

  }

  loadChartsData() {
    let datasetsChartFatturatoData = [], labelsChartFatturatoData = [];

    //dataset for fatturato: delta and fatturato cliente and bilancio
    datasetsChartFatturatoData.push(
      {
        label: 'Fatturato ' + this.state.clientData.name,
        fill: false,
        lineTension: 0,
        backgroundColor: 'rgba(' + this.state.clientData.color + ',0.4)',
        borderColor: 'rgba(' + this.state.clientData.color + ',1)',
        dataValues: [this.state.clientData.chartDeltaFatturatoBilancioData][0],
        data: [this.state.clientData.chartFatturatoBilancioData][0]
      })
    datasetsChartFatturatoData.push(
      {
        label: 'Fatturato Stimato ' + this.state.clientData.name,
        fill: false,
        lineTension: 0,
        backgroundColor: 'rgba(' + this.state.clientData.color + ',0.4)',
        borderColor: 'rgba(' + this.state.clientData.color + ',1)',
        dataValues: [this.state.clientData.chartDeltaFatturatoBilancioEstimatedData][0],
        data: [this.state.clientData.chartFatturatoBilancioEstimatedData][0],
        borderDash: [10, 5]
      })
    labelsChartFatturatoData = this.state.clientData.chartFatturatoBilancioLabels


    let { chartFatturatoData } = this.state
    chartFatturatoData.datasets = datasetsChartFatturatoData
    chartFatturatoData.labels = labelsChartFatturatoData

    this.setState({
      chartFatturatoData,
      loading: false
    })
  }

  async componentDidMount() {
    Chart.plugins.register(ChartDataLabels);
    //dati per scheda
    let response = await Http.get(`${this.api}/client/${this.props.clientId}?type=evolution`)
    const { data } = response.data;
    if (data == []) {
      // alert('Si è verificato un errore: competitor non valido')
      this.setState({
        error: 'Si è verificato un errore: competitor non valido',
        loading: false
      });
    }

    //dati per simulazione
    let formData = new FormData()
    let res
    formData.append('filters', JSON.stringify({
      indexName: 'mappa',
      indexType: 'evolution',
      max_result: 1000,
      clientsId: [this.props.clientId],
      from: this.props.user.reports.newestReportYear - 4,
      to: this.props.user.reports.newestReportYear,
    }))
    res = await axios.post(`${this.api}/clients-with-filters`, formData)
    this.setState({
      clientData: data,
      clientsData: res.data.data,
    });

    this.loadChartsData()

  }

  componentWillUnmount() {
    this.setState({
      showEditMode: false,
    })
  }

  async toggleEditMode() {
    window.scrollTo(0, 0);
    if (this.state.showEditMode) {
      Chart.plugins.register(ChartDataLabels);
      this.setState({
        showEditMode: false,
      })
    } else {
      this.setState({
        showEditMode: true
      })
    }
  }

  render() {
    let { clientData } = this.state
    if (this.state.loading) {
      return (
        <div className="content text-center">
          <Spinner style={{ width: '3rem', height: '3rem' }} type="grow" />
        </div>
      )
    } else {
      if (this.state.showEditMode) {
        return (null)
      } else {
        let textQuotaMercato = '', textEXP = '', symbolQuotaMercato = ''
        if (clientData.chartQuotaMercatoData[clientData.chartQuotaMercatoData.length - 1] > clientData.chartQuotaMercatoData[clientData.chartQuotaMercatoData.length - 2]) {
          textQuotaMercato = 'text-success'
          symbolQuotaMercato = (<FontAwesomeIcon icon={faArrowUp} size="xs" />)
        } else if (clientData.chartQuotaMercatoData[clientData.chartQuotaMercatoData.length - 1] = clientData.chartQuotaMercatoData[clientData.chartQuotaMercatoData.length - 2]) {
          textQuotaMercato = 'text-warning'
          symbolQuotaMercato = (<FontAwesomeIcon icon={faEquals} size="xs" />)
        } else {
          textQuotaMercato = 'text-danger'
          symbolQuotaMercato = (<FontAwesomeIcon icon={faArrowDown} size="xs" />)
        }

        if (clientData.chartEXPData[clientData.chartEXPData.length - 1] >= 60) {
          textEXP = 'text-success'
        } else if (clientData.chartEXPData[clientData.chartEXPData.length - 1] >= 30) {
          textEXP = 'text-warning'
        } else {
          textEXP = 'text-danger'
        }

        return (<Row>
          <Col md="12">
            <Card>
              <Row>
                <Col md="12">
                  <h3 className="text-left m-3 text-secondary font-weight-light">COMPETITOR: <span className="text-primary font-weight-bold">{clientData.name}</span></h3>
                </Col>
                <Col md={clientData.targets ? "3" : "6"} className="text-center">
                  <h4 className="card-title text-secondary font-weight-light">CPF</h4>
                  <h3 className="text-primary font-weight-bold mb-0">{clientData.chartCPFData[clientData.chartCPFData.length - 1]}</h3>
                </Col>
                <Col md={clientData.targets ? "3" : "6"} className="text-center">
                  <h4 className="card-title text-secondary font-weight-light">EXP</h4>
                  <h3 className={textEXP + " font-weight-bold mb-0"}>{clientData.chartEXPData[clientData.chartEXPData.length - 1]}</h3>
                </Col>

                {clientData.targets && (<Col md="3" className="text-center">
                  <h4 className="card-title text-secondary font-weight-light">OBIETTIVO</h4>
                  <h3 className="text-info font-weight-bold mb-0">{FormatNumberInEur(clientData.targets.target)}</h3>
                </Col>)}
                {clientData.targets && (
                  < Col md="3" className="text-center">
                    <h4 className="card-title text-secondary font-weight-light">EXPECTED TARGET</h4>
                    <h3 className="text-primary font-weight-bold mb-0">{FormatNumberInEur(clientData.targets.expected_target)}</h3>
                  </Col>)}


                <Col md="12" >
                  <Card>
                    <CardBody>
                      <Line height={70} width={null}
                        data={this.state.chartFatturatoData}
                        options={this.state.chartDeltaOptions} />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md="4" className="text-center mt-1">
                  <h6 className="card-title text-secondary font-weight-light">{'QUOTA MERCATO ' + this.props.user.reports.newestReportYear}</h6>
                  <h4 className={textQuotaMercato + " font-weight-bold"}>{clientData.chartQuotaMercatoData[clientData.chartQuotaMercatoData.length - 1] + ' % '}{symbolQuotaMercato}</h4>
                </Col>
                <Col md="4" className="text-center mt-1">
                  <h6 className="card-title text-secondary font-weight-light">{'QUOTA MERCATO ' + (this.props.user.reports.newestReportYear - 1)}</h6>
                  <h4 className="text-secondary font-weight-bold">{clientData.chartQuotaMercatoData[clientData.chartQuotaMercatoData.length - 2]} %</h4>
                </Col>
                <Col md="4" className="text-center mt-1">
                  <h6 className="card-title text-secondary font-weight-light">QUOTA DI MERCATO PIÙ ALTA</h6>
                  <h4 className="text-secondary font-weight-bold">{clientData.quotaMercatoRecordData + '% nel ' + clientData.quotaMercatoRecordYear}</h4>
                </Col>
                <Col md="4" className="text-center mt-1">
                  <h6 className="card-title text-secondary font-weight-light">FATTURATO {clientData.chartFatturatoBilancioEstimatedLabels[clientData.chartFatturatoBilancioData.length - 3]}</h6>
                  <h4 className="text-secondary font-weight-bold">{FormatNumberInEur(clientData.chartFatturatoBilancioData[clientData.chartFatturatoBilancioData.length - 3])} </h4>
                </Col>
                <Col md="4" className="text-center mt-1">
                  <h6 className="card-title text-secondary font-weight-light">PROIEZIONE FATTURATO {clientData.chartFatturatoBilancioEstimatedLabels[clientData.chartFatturatoBilancioData.length - 2]}</h6>
                  <h4 className="text-secondary font-weight-bold">{FormatNumberInEur(clientData.chartFatturatoBilancioEstimatedData[clientData.chartFatturatoBilancioEstimatedData.length - 2])} </h4>
                </Col>
                <Col md="4" className="text-center mt-1">
                  <h6 className="card-title text-secondary font-weight-light">TENDENZA FATTURATO {clientData.chartFatturatoBilancioEstimatedLabels[clientData.chartFatturatoBilancioData.length - 1]}</h6>
                  <h4 className="text-secondary font-weight-bold">{FormatNumberInEur(clientData.chartFatturatoBilancioEstimatedData[clientData.chartFatturatoBilancioEstimatedData.length - 1])}  </h4>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col md="12" >
            <Card>
              <Row>
                <Col>
                </Col>
                <Col>
                  <Link to={'/statistiche-competitor/' + clientData.id} alt="Statistiche competitor">
                    <Button className="animation-on-hover float-right m-3 text-center" color="primary" >Statistiche</Button>
                  </Link>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row >
        )
      }
    }
  }
}

ClientEvolutionDetails.propTypes = {
  clientId: PropTypes.number.isRequired,
};

export default ClientEvolutionDetails;
